import React, { useState } from "react";
import { CAlert, CButton, CButtonGroup, CCol, CRow, CSpinner } from "@coreui/react";
import DatePickerDaysExample from "../Date/DatePicker";
import { quickRangeDates, validateDateRange } from "../../../utils/dateRange";

export default function PeriodFilters({
  fromDate,
  toDate,
  onFromChange,
  onToChange,
  onRefresh,
  maxDays = 31,
  showQuickRanges = true,
  quickRange = "",
  onQuickRangeChange,
  refreshLabel = "Обновить",
  disabled = false,
  loading = false,
}) {
  const [rangeError, setRangeError] = useState("");

  const checkRange = (from, to) => {
    const result = validateDateRange(from, to, maxDays);
    setRangeError(result.ok ? "" : result.error);
    return result.ok;
  };

  const applyQuick = (key) => {
    const { from, to, key: rk } = quickRangeDates(key);
    if (!checkRange(from, to)) return;
    onFromChange(from);
    onToChange(to);
    onQuickRangeChange?.(rk);
    onRefresh?.(from, to);
  };

  const handleRefresh = () => {
    if (!checkRange(fromDate, toDate)) return;
    onQuickRangeChange?.("");
    onRefresh?.(fromDate, toDate);
  };

  return (
    <div>
      {rangeError && (
        <CAlert color="warning" className="mb-3">
          {rangeError}
        </CAlert>
      )}
      <CRow className="g-2 align-items-end">
        <CCol xs={12} md={4}>
          <div className="d-flex align-items-center gap-1">
            <span className="text-body-secondary small text-nowrap" style={{ width: 26 }}>
              С:
            </span>
            <div className="flex-grow-1">
              <DatePickerDaysExample
                isFromDate
                value={fromDate}
                onChange={(d) => {
                  onFromChange(d);
                  checkRange(d, toDate);
                }}
              />
            </div>
          </div>
        </CCol>
        <CCol xs={12} md={4}>
          <div className="d-flex align-items-center gap-1">
            <span className="text-body-secondary small text-nowrap" style={{ width: 26 }}>
              По:
            </span>
            <div className="flex-grow-1">
              <DatePickerDaysExample
                isFromDate={false}
                value={toDate}
                onChange={(d) => {
                  onToChange(d);
                  checkRange(fromDate, d);
                }}
              />
            </div>
          </div>
        </CCol>
        {onRefresh && (
          <CCol xs={12} md="auto" className="d-grid">
            <CButton color="primary" onClick={handleRefresh} disabled={disabled}>
              {loading ? (
                <>
                  <CSpinner size="sm" className="me-2" />
                  Загрузка…
                </>
              ) : (
                refreshLabel
              )}
            </CButton>
          </CCol>
        )}
      </CRow>
      {showQuickRanges && (
        <CRow className="mt-2">
          <CCol>
            <CButtonGroup role="group" aria-label="Быстрый выбор периода">
              <CButton
                color="primary"
                variant={quickRange === "yesterday_today" ? "outline" : undefined}
                onClick={() => applyQuick("yesterday_today")}
                disabled={disabled}
              >
                Вчера и сегодня
              </CButton>
              <CButton
                color="primary"
                variant={quickRange === "3days" ? "outline" : undefined}
                onClick={() => applyQuick("3days")}
                disabled={disabled}
              >
                За 3 дня
              </CButton>
              <CButton
                color="primary"
                variant={quickRange === "week" ? "outline" : undefined}
                onClick={() => applyQuick("week")}
                disabled={disabled}
              >
                За неделю
              </CButton>
              <CButton
                color="primary"
                variant={quickRange === "month" ? "outline" : undefined}
                onClick={() => applyQuick("month")}
                disabled={disabled}
              >
                За месяц
              </CButton>
            </CButtonGroup>
          </CCol>
        </CRow>
      )}
    </div>
  );
}
